var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Turnstile } from './constants';
/**
 * @description This function is used to track the turnstile event and is a generic function that can be used to track any turnstile event
 */
export var trackTurnstileEvent = function (_a) {
    var event = _a.event, _b = _a.props, props = _b === void 0 ? {} : _b, _c = _a.trackingOptions, trackingOptions = _c === void 0 ? {} : _c;
    window.trackEventsForGuests(event, __assign(__assign({}, props), { "custom_user_type": Turnstile.USER_TYPES.UNVERIFIED }), __assign({ send_datadump: true, send_mixpanel: true, send_clevertap: false }, trackingOptions));
};
/**
 * @description This function is used to create the turnstile event tracker with common props using the turnstile data ref and is a wrapper function over the trackTurnstileEvent function
 */
export var createTurnstileEventTracker = function (turnstileData, actionSource) {
    return function (_a) {
        var event = _a.event, _b = _a.props, props = _b === void 0 ? {} : _b, _c = _a.trackingOptions, trackingOptions = _c === void 0 ? {} : _c;
        trackTurnstileEvent({
            event: event,
            props: __assign(__assign(__assign({}, getCommonTurnstileEventProps(turnstileData)), props), { action_source: actionSource }),
            trackingOptions: trackingOptions
        });
    };
};
/**
 * @description This function is used to get the common turnstile event props using the turnstile data ref
 */
var getCommonTurnstileEventProps = function (turnstileData) {
    var timing = turnstileData.current.timing;
    var scriptLoadStartTime = timing.scriptLoadStartTime, scriptLoadEndTime = timing.scriptLoadEndTime, scriptLoadDuration = timing.scriptLoadDuration, formSubmitTime = timing.formSubmitTime, challengeStartTime = timing.challengeStartTime, challengeEndTime = timing.challengeEndTime, challengeDuration = timing.challengeDuration, submitToChallengeEndDuration = timing.submitToChallengeEndDuration;
    return {
        script_load_start_time: scriptLoadStartTime || null,
        script_load_end_time: scriptLoadEndTime || null,
        script_load_duration: scriptLoadDuration || null,
        challenge_start_time: challengeStartTime || null,
        challenge_end_time: challengeEndTime || null,
        challenge_duration: challengeDuration || null,
        form_submit_time: formSubmitTime || null,
        submit_to_challenge_end_duration: submitToChallengeEndDuration || null,
    };
};
/**
 * @description This function is used to check if the turnstile is enabled
 */
export var turnstileEnabled = function () {
    var _a;
    return (_a = window.turnstile_enabled_features) === null || _a === void 0 ? void 0 : _a.parent_and_teacher_signup;
};
/**
 * @description This function is used to check if the turnstile should be polled
 */
export var shouldPollTurnstileToken = function (turnstileData) {
    // If script load failed, don't poll
    if (turnstileData.current.scriptLoadFailed) {
        return false;
    }
    return (!turnstileData.current.loaded || turnstileData.current.tokenExpired || (!turnstileData.current.token && !turnstileData.current.errorCode));
};
/**
 * @description This function is used to poll for the turnstile token
 */
export var pollTurnstileToken = function (shouldPoll, interval, maxWaitTime, callback, timeoutCallback, setShowTurnstileSpinner, turnstileData) {
    var elapsed = 0;
    function check() {
        var result = shouldPoll();
        if (!result) {
            callback(result);
        }
        else if (elapsed >= maxWaitTime) {
            timeoutCallback();
        }
        else {
            setShowTurnstileSpinner(true);
            elapsed += interval;
            turnstileData.current.pollTimeoutId = setTimeout(check, interval);
        }
    }
    check();
};
